import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

export const DealPromptDirectTag = () => {
  const { t } = useTranslation();

  return (
    <Typography
      sx={{
        textTransform: 'uppercase',
        color: 'primary.main',
        fontWeight: 'fontWeightBold',
        fontSize: 10,
        whiteSpace: 'nowrap',
      }}
    >
      {t('Direct')}
    </Typography>
  );
};
